export default __webpack_public_path__ + "static/media/9-sitzer-bus-background.58f806a2.jpg";